<template>
  <div class="select-list-component">
    <v-item-group class="select-list-search">
      <v-select
        label="Selecione a forma de pesquisa"
        :items="searchTypes"
        outlined
        editable
        style="flex: 1;"
        :value="searchOption.value"
        @change="selectSearchOption"
      ></v-select>

      <v-text-field
        type="text"
        v-model="searchOption.search"
        placeholder="Pesquisar"
        style="flex: 2;"
        outlined
        dense
      ></v-text-field>
      <v-btn
        :value="1"
        @click="loadItems(true)"
        color="primario"
        style="flex: 1; padding: 20px 0"
        elevation="0"
      >
        Pesquisar
      </v-btn>
    </v-item-group>

    <div class="list">
      <div>
        <keep-alive>
          <ListComponent
            :default-itens="items"
            :list-size="listHeight"
            :disable-options="disableOptions"
            :showSearch="showSearchList"
            @on-scroll="hasMoreItems && loadItems(false)"
            @onSearch="searchObjects"
          >
          </ListComponent>
        </keep-alive>
      </div>
      <div class="btn-container">
        <v-overlay :value="loading" absolute>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <FormButton
          text="Adicionar todos"
          @click="addItems(true)"
          type="submissao"
          outlined
          color="green"
          :disabled="disableButton || loading"
          after-icon="fas fa-chevron-right"
        />
        <FormButton
          text="Adicionar"
          @click="addItems(false)"
          type="submissao"
          :disabled="disableButton || loading"
          after-icon="fas fa-chevron-right"
        />
        <FormButton
          text="Remover"
          @click="removeItems(false)"
          type="perigo"
          :disabled="disableButton || loading"
          before-icon="fas fa-chevron-left"
        />
        <FormButton
          text="Remover todos"
          @click="removeItems(true)"
          :disabled="disableButton || loading"
          type="perigo"
          outlined
          color="red"
          before-icon="fas fa-chevron-left"
        >
        </FormButton>
      </div>
      <div>
        <keep-alive>
          <ListComponent
            :default-itens="itemsAddedd"
            :list-size="listHeight"
            :showSearch="showAddedListSearch"
            @on-scroll="loadAddedItems()"
            @onSearch="searchAddedObjects"
          >
          </ListComponent>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ListComponent from "./ListComponent";
import FormButton from "../../components/form/FormButton";
import ApiWeb from "../../service/api-web";
import * as _ from "lodash";

export default {
  name: "SelectListComponent",
  components: { ListComponent, FormButton },
  props: {
    value: Array,
    addAllItems: Array,
    searchEndpoint: {
      type: String,
      required: true
    },
    searchEndpointParams: {
      type: String,
      default: ""
    },
    loadEndpoint: {
      type: String,
      required: true
    },
    searchTypes: {
      type: Array
    },
    listHeight: {
      type: String,
      default: "400px"
    },
    itemsPerPage: {
      type: Number,
      default: 20,
      required: false
    },
    showSearchList: {
      type: Boolean,
      default: false
    },
    disableButton: {
      type: Boolean,
      default: false
    },
    showAddedListSearch: {
      type: Boolean,
      default: false
    },
    disableOptions: {
      type: Object,
      default: null,
      required: false
    },
    itemOptions: {
      type: Object,
      default: null,
      required: false
    }
  },
  data: function() {
    return {
      currentPage: 0,
      items: [],
      itemsAddedd: [],
      loading: false,
      searchOption: {
        text: "",
        value: "",
        search: ""
      },
      loadItemPos: 0,
      searchList: "",
      searchAddedList: "",
      hasMoreItems: true,
      allItemsAdded: false,
      isNewSearch: false
    };
  },
  computed: {
    ...mapGetters(["darkEnabled"])
  },
  watch: {
    searchAddedList() {
      this.debouncedLoadAddedItens(true);
    },
    addAllItems(val) {
      this.itemsAddedd = val;
    }
  },
  mounted() {
    if (this.searchTypes && this.searchTypes.length > 0) {
      this.selectSearchType(this.searchTypes[0]);
    }
    this.loadItemPos = 0;
    this.loadItems(true).then(() => this.loadAddedItems());
  },
  methods: {
    searchObjects(val) {
      this.searchList = val;
    },
    searchAddedObjects(val) {
      this.searchAddedList = val;
    },
    debouncedLoadItens: _.debounce(function() {
      this.loadItems(true);
    }, 500),
    debouncedLoadAddedItens: _.debounce(function() {
      this.loadAddedItems(true);
    }, 500),
    loadItems(clear = false) {
      return new Promise(resolve => {
        if (clear) {
          this.currentPage = 0;
          this.items = [];
          this.hasMoreItems = true;
          this.allItemsAdded = false;
          this.isNewSearch = true;
        }

        if (!this.hasMoreItems && !clear) {
          resolve([]);
          return;
        }

        this.currentPage = clear ? 0 : this.currentPage + 1;

        const params = `&${this.searchOption.value}=${this.searchOption.search}${this.searchEndpointParams}`;
        const url = `${this.searchEndpoint}?page=${
          this.currentPage
        }&perpage=${this.itemsPerPage || 20}${params}`;

        this.loading = true;
        ApiWeb.api
          .get(url)
          .then(resp => {
            const items = resp.data || [];
            if (items.length < (this.itemsPerPage || 20)) {
              this.hasMoreItems = false;
            }
            this.mapItems(items, clear);
            resolve(items);
          })
          .catch(resolve)
          .finally(() => {
            this.loading = false;
          });
      });
    },

    async addItems(all = false) {
      this.$emit("fetching", true);
      try {
        if (all) {
          let selectedItems = [];

          while (this.hasMoreItems) {
            await this.loadItems(false);
          }
          selectedItems = this.items.map(item => ({
            ...item,
            selected: false
          }));

          const shouldReplace = this.isNewSearch;
          this.prepareItensToUpdate(
            selectedItems,
            shouldReplace ? [] : this.value
          );
          this.allItemsAdded = true;
          this.isNewSearch = false;
          this.$emit("add-all-items", this.itemsAddedd, selectedItems);
          this.$emit("change", true);
        }

        if (!all) {
          let selectedItems = (this.items || [])
            .filter(item => item.selected)
            .map(function(item) {
              return { ...item, selected: false };
            });
          this.prepareItensToUpdate(selectedItems, this.value);
          this.isNewSearch = false;
          this.$emit("change", true);
        }
      } finally {
        this.$emit("fetching", false);
      }
    },
    prepareItensToUpdate(selectedItems, originalArray) {
      if (!selectedItems.length) return;

      const keyid = _.get(this.itemOptions, "id", null);
      const key = _.get(this.itemOptions, "key", null);

      let newValues;

      if (originalArray && originalArray.length === 0) {
        newValues = _.uniqBy([...selectedItems], keyid);
        this.itemsAddedd = newValues.filter(o => o[key]);
      } else {
        newValues = _.uniqBy(
          [
            ...(this.itemsAddedd || []),
            ...selectedItems,
            ...(originalArray || [])
          ],
          keyid
        );
        this.itemsAddedd = newValues.filter(o => o[key]);
      }

      this.$emit("input", newValues);
    },
    removeItems(all = false) {
      if (all) {
        this.itemsAddedd = [];
        this.allItemsAdded = false;
        this.isNewSearch = false;
        this.$emit("remove-all", true);
        this.$emit("change", true);
        return this.$emit("input", []);
      }
      this.$emit("fetching", true);
      let keyid = _.get(this.itemOptions, "id", null);
      let itensRemovidos = this.itemsAddedd.filter(i => i.selected);
      const newValues = _.pullAllBy(this.value, itensRemovidos, keyid);
      this.itemsAddedd = _.remove(this.itemsAddedd, i => i.selected === false);

      if (this.itemsAddedd.length < this.value.length) {
        this.allItemsAdded = false;
      }

      this.$emit("input", newValues);
      this.$emit("fetching", false);
      this.$emit("remove-itens", itensRemovidos);
      this.$emit("change", true);
    },
    mapItems(items, clear = false) {
      let list = (items || []).map(item => this.mapItem(item));
      if (clear) {
        this.items = list;
      } else {
        this.items = (this.items || []).concat(list);
      }
    },
    mapItem(item) {
      const { key, obs = [] } = this.itemOptions;
      if (this.itemOptions && key) {
        let nome = _.get(item, key, "");
        let _obs = obs
          .map(o => {
            return item[o];
          })
          .filter(oo => oo);
        return {
          ...item,
          nome,
          obs: _obs,
          selected: false
        };
      }
      return {
        ...item,
        selected: false
      };
    },
    selectSearchOption(option) {
      this.searchOption.value = option;
    },
    selectSearchType(type) {
      this.searchOption = {
        text: "",
        value: "",
        ...type
      };
    },
    reloadAddedItems() {
      this.loadItemPos = 0;
      this.allItemsAdded = false;
      this.itemsAddedd = [];
      return this.loadAddedItems(false);
    },
    async loadAddedItems(isSearching = false) {
      if (!this.loadEndpoint || !this.value || this.value.length === 0) return;

      if (this.allItemsAdded && !isSearching) {
        return;
      }

      if (isSearching) {
        isSearching = false;
        this.loadItemPos = 0;
        this.allItemsAdded = false;
        this.itemsAddedd = [];
      }

      let keyid = _.get(this.itemOptions, "id", "id");
      let payloadProp = _.get(this.itemOptions, "payloadProp", "id");

      let allIds = (this.value || [])
        .map(item => {
          if (typeof item === "object" && item !== null) {
            return _.get(item, keyid, "");
          }
          return item;
        })
        .filter(id => id !== null && id !== undefined && id !== "");

      const batchSize = 500;
      const startIdx = this.loadItemPos;
      const endIdx = Math.min(startIdx + batchSize, allIds.length);
      const listaIds = allIds.slice(startIdx, endIdx);

      const hasSearch =
        this.searchAddedList != null && this.searchAddedList !== "";
      if (listaIds.length === 0 && !hasSearch) return;

      const payload = hasSearch ? {} : { [payloadProp]: listaIds };
      const url = `${this.loadEndpoint}?search=${this.searchAddedList}&paginate=false`;
      const resp = await ApiWeb.api.post(url, payload);

      const data = (resp.data || [])
        .map(item => {
          const itemId = _.get(item, keyid, null);
          const found = allIds.some(id => id == itemId);
          return found ? this.mapItem(item) : null;
        })
        .filter(item => item !== null);

      this.itemsAddedd = (this.itemsAddedd || []).concat(data);
      this.itemsAddedd = _.uniqBy(this.itemsAddedd, keyid);

      this.loadItemPos = endIdx;

      if (endIdx < allIds.length && !hasSearch) {
        await this.loadAddedItems(isSearching);
      } else {
        this.allItemsAdded = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.select-list-search {
  display: flex;
  height: 55px;
  margin-bottom: 10px;
  padding: 5px 5px;
  .select {
    margin: unset;
  }
}
.select-list-component {
  .list {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 5px;
  }
  .btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    button {
      margin: 2px 0;
    }
  }
}
@media (max-width: 1100px) {
  .select-list-component {
    .btn-container {
      flex-direction: row;
      justify-content: space-evenly;
    }
    .select-list-search {
      margin-bottom: unset;
    }

    .list {
      flex-direction: column;
      padding: 10px;
      div {
        padding: 10px;
        align-self: center;
      }
    }
  }
}
</style>
